import * as React from "react";
import { Controller, ControllerProps, FieldPath, FieldValues } from "react-hook-form";
import { FormFieldContext } from "./form-contexts";

// Minimal useFormField hook for context access


// Only the component export remains here for Fast Refresh compliance
export function FormField<TFieldValues extends FieldValues = FieldValues, TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>>(
  props: ControllerProps<TFieldValues, TName> & { error?: import('react-hook-form').FieldError }
): JSX.Element {
  const id = React.useId();
  return (
    <FormFieldContext.Provider
      value={{
        name: props.name,
        error: props.error,
        formItemId: `form-item-${id}`,
        formDescriptionId: `form-item-desc-${id}`,
        formMessageId: `form-item-msg-${id}`,
      }}
    >
      <Controller {...props} />
    </FormFieldContext.Provider>
  );
}

